import { createSlice }   from '@reduxjs/toolkit';
import { authenticationExtraReducers } from 'Redux/Reducers/Authentication';

export interface IAuthenticationState {
  accessToken: null| string,
  refreshToken: null| string,
  accessTokenExpiresAt: null| Date,
  refreshTokenExpiresAt: null| Date
}

export const authenticationSlice = createSlice({
  name: 'authentication',
  initialState: {
    accessToken: null,
    refreshToken: null,
    accessTokenExpiresAt: null,
    refreshTokenExpiresAt: null
  },
  reducers: {},
  extraReducers: authenticationExtraReducers,

});
